import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import classNames from 'classnames';
import { ROUTES } from 'configs/routes/constants';
import NotificationService from 'modules/notification/NotificationService';
import PropTypes from 'prop-types';

import { EVENT_TYPE } from '../../constants';

export default class NotificationItemStandard extends PureComponent {
  static propTypes = {
    event: PropTypes.string,
    img: PropTypes.string,
    id: PropTypes.string,
    read: PropTypes.bool,
    children: PropTypes.node,
    onClick: PropTypes.func
  };

  onClick = () => {
    const { event, id: key } = this.props;

    if (event !== EVENT_TYPE.PLACEHOLDER) {
      NotificationService.setItemRead(key);
    }
  };

  render() {
    const { event = '', read } = this.props;

    const className = classNames(
      'notification__item',
      `notification__item__${event.toLowerCase()}`,
      { 'notification__item--unread': !read }
    );

    return (
      <Link
        to={ROUTES.COMMUNITY.LIST}
        onClick={this.onClick}
        className="_text-decoration-none"
      >
        <li className={className}>
          <div className="notification__img">{this.renderImg}</div>
          <div className="notification__content">{this.renderContent}</div>
        </li>
      </Link>
    );
  }
}
